import styled from 'styled-components'
import { alertRed } from 'styles/styleVariables'

interface TriageAlertProps {
  text: string
}

const TriageAlertContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0.5rem 0;
`
const TriageAlertText = styled.div`
  color: ${alertRed};
  font-size: 1.2rem;
  font-weight: bold;
  padding: 0 0.5rem;
`

const TriageAlert = ({ text }: TriageAlertProps) => {
  return (
    <TriageAlertContainer>
      <TriageAlertText>{text}</TriageAlertText>
    </TriageAlertContainer>
  )
}

export default TriageAlert
